module.exports = __webpack_public_path__ + "images/emoji/speaker.afe8d0ab93d6773d26cf.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/speaker.png
// module id = p56V
// module chunks = 24